
module.directive('initiativeDates', function($http, ApiUrl, Notifications) {
return {
        restrict: 'E',
        templateUrl: 'programs/initiatives/dates',
        scope: {
            initiative: '=',
            canEdit: '=',
        },
        link: function(scope, element, attrs) {

            scope.data = null;

            scope.showForm = function() {
                if (!scope.canEdit) return;
                scope.data = {
                    start_date: scope.initiative.start_date,
                    end_date: scope.initiative.end_date,
                };
            };

            scope.hideForm = function() {
                scope.data = null;
            };

            scope.save = function(form, data) {
                if (form.$invalid) {
                    Notifications.canned('form_errors');
                    return;
                }

                $http.put(ApiUrl('initiative', scope.initiative.id), data)
                    .then(_success, _error);
            };

            function _success(response) {
                Notifications.success('Initiative dates updated.')
                scope.initiative.start_date = response.data.initiative.start_date;
                scope.initiative.end_date = response.data.initiative.end_date;
                scope.hideForm();
            }

            function _error(response) {
                Notifications.error('An unknown error occured');
            }
        },
    };
});
